module.exports = __webpack_public_path__ + "static/SharpGrotesk-Bold-bbe732b10e1d08c6876f47018c077de5.otf";